export const CreateProjectStepsTitle = ({ step, title = '' }: { step: number; title?: string }) => {
  return (
    <div
      className={
        'absolute flex gap-[5px] -top-10 left-4 z-10 overflow-auto w-[calc(100%-195px)] items-center opacity-30'
      }
    >
      <div>
        <p className={'text-ebony text-base-xs font-medium'}>
          Step {step} - <b>{title}</b>
        </p>
      </div>
    </div>
  );
};
